module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAQCAYAAAAmlE46AAABI0lEQVQokY3SsS9kURSA8d+7pttEoZqRSDYSEj0VCnRCi3bVEtELEyQqotDYYrPVakxD8A8QpcaKSjuJkqhInsJ5MeQZTnJzcnK+L++8e25Wr9eVRbVaPcuyLG82m6Nl/UqtVisVMQyf9dNn1lfRKs7iP8ZLuAlcBwMqkefwDxl+log9GMA+ntFI6MZeSKv4UyL+xUowv1FNWEAnTrHW5rfWcYIuLCZMRWOrlcrz/BznH+TtyJMV9EVx0UpkWTZS8tWC6U8xN3S0GbOIYgvPCTdRDH5DHIp8m3AYxdI3xII5TtjFPaax3EZaDuYeOwl3mEfu9cqPMIYfccZiqvVg5nFXvJwGZrwuf8rbilrjAb+CffdWD9CLTVzhCY+4xEb0GgX8AsGdOX3xiULSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/pp34.png
// module id = Bj7+
// module chunks = 34